import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import styles from './ActionColumnManager.module.scss';
import { Action, Button, Checkbox, Columns } from 'esa-ui-library';
import { ColumnMangerOptionType, useStore } from '../../../../../common';
import { createDropdownOptions, getColumnValues, getUpdateOptions } from './ActionColumnManager.helper';

const ActionColumnManager = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const [opened, setOpened] = useState(false);
	const [options, setOptions] = useState<ColumnMangerOptionType[]>([]);
	const isActive = state?.initialColumns?.length !== state?.columns?.length;

	const onCheckItem = (item: ColumnMangerOptionType) => {
		setOptions(getUpdateOptions(item, options));
	};

	const onApply = () => {
		const formatColumns = getColumnValues(options);
		setOpened(false);
		dispatch('UPDATE_COLUMNS', formatColumns);
	};

	const onReset = () => {
		setOptions(createDropdownOptions(state.initialColumns, state.initialColumns));
	};

	useEffect(() => {
		if (state?.initialColumns?.length > 0 && state?.columns?.length > 0) {
			setOptions(createDropdownOptions(state.initialColumns, state.columns));
		}
	}, [state.initialColumns, state.columns]);

	const renderList = (list: ColumnMangerOptionType[]) =>
		list.map((s: ColumnMangerOptionType) => (
			<div key={s.value} className={cx(styles.Item, { [styles.Disabled]: s.isDisabled })}>
				<p className={styles.Label}>{s.label}</p>
				<Checkbox
					checked={s.isChecked}
					className={styles.Option}
					onChange={() => {
						onCheckItem(s);
					}}
				/>
			</div>
		));

	return (
		<Action
			label='Manage Columns'
			icon={<Columns />}
			select
			controlled
			onDropdownChange={setOpened}
			opened={opened}
			iconPosition='right'
			className={cx(styles.Button, { [styles.Active]: isActive })}
			dataId='action-column-manager'
			noArrow
		>
			<section data-testid='column-list' onClick={(e) => e.stopPropagation()} className={styles.List}>
				{renderList(options)}
				<div className={styles.ButtonBox}>
					<Button teritary title='Reset' onClick={onReset} small className={styles.ResetButton} />
					<Button teritary title='Apply' onClick={onApply} small />
				</div>
			</section>
		</Action>
	);
};

export { ActionColumnManager };
